import { number, shape } from 'prop-types'

const crossSellWidgetPropTypes = shape({
  sae: number.isRequired,
  mp: number.isRequired,
})

const crossSellStartPageAlternative = shape({ alternative: number })
const crosssSellExpaHidden = shape({
  startPage: crossSellStartPageAlternative,
})

export { crossSellWidgetPropTypes, crosssSellExpaHidden }
